import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken, EmulatedProductData } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_JOBS = false


/*
 * Jobs Actions
 * 
 */

export function fetchJobsList() {
    let cmd = 'FETCH_JOBS_LIST'

    if (EMULATION_ALL || EMULATION_MODE_JOBS)
        //TODO - needs to be fixed
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('BackgroundJobs/Paged'), {}, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchJobsUpdatedList(filter) {
    let cmd = 'FETCH_JOBS_LIST_UPDATED'

    if (EMULATION_ALL || EMULATION_MODE_JOBS)
        //TODO - needs to be fixed
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: filter.pageNumber
                    }
                }
            )

            axios.post(buildRequestUrl(filter.jobType ? 'BackgroundJobs/Paged?jobType=' + filter.jobType : 'BackgroundJobs/Paged'), JSON.stringify(filter), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchJob(id) {
    let cmd = 'FETCH_JOBS'

    if (EMULATION_ALL || EMULATION_MODE_JOBS)
        //TODO - needs to be fixed
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('BackgroundJobs/') + id, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchJobFile(job) {
    let cmd = 'FETCH_JOB_FILE'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.get(
                buildRequestUrl('BackgroundJobs/File/') + job.importJobId,
                {
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                    responseType: 'blob'
                })
            .then((response) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: response
                    }
                );

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                if (job.jobType == "4") {
                    link.setAttribute('download', "Unprocessed_Records_Export_" + job.importJobId + ".xlsx");
                } else if (job.jobType == "5") {
                    link.setAttribute('download', job.input.substring(job.input.lastIndexOf("\\") + 1));
                } else {
                    link.setAttribute('download', 'UnknownFile');
                }
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function createJob(job) {
    let cmd = 'CREATE_JOB'

    if (EMULATION_ALL || EMULATION_MODE_JOBS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: job
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('BackgroundJobs'), JSON.stringify(job), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchJobsError(dispatch) {
    dispatch(
        {
            type: 'FETCH_JOBS_ERROR',
        }
    )
}

export function errorJob(dispatch) {

    dispatch(
        {
            type: 'JOB_ERROR',
        }
    )
}
